import React from "react"
import BackgroundImage from "gatsby-background-image"
// import { Parallax, Background } from "react-parallax"
// import { Link } from "gatsby"

export default function HeroSection({ img, title, subtitle, heroclass, page }) {
  // const [offsetY, setOffsetY] = useState(0)
  // const handleScroll = () => setOffsetY(window.pageYOffset)
  // const q = document.getElementsByClassName({ heroclass })
  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll)
  //   return () => window.removeEventListener("scroll", handleScroll)
  //   q.style = { transform: `translate(${offsetY * 0.5}px)` }
  // })

  return (
    <BackgroundImage className={heroclass} fluid={img}>
      <div className="parallax-item flex-grow-3">
        <h1 className="title text-warning text-center display-4">{title}</h1>
      </div>
      <div>
        <h4 className="text-warning">{subtitle}</h4>
      </div>
      {/* <Link to={page}>
        <button className="btn btn-warning">Click here</button>
      </Link> */}
    </BackgroundImage>
  )
}
